import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'nwt-power-supply-created-dialog',
  templateUrl: './power-supply-created-dialog.component.html'
})

export class PowerSupplyCreatedDialog implements OnInit {

  powerSupplyName: string = '';
  nodeId: number = 0;
  nonComcast: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PowerSupplyCreatedDialog>,
    @Inject(MAT_DIALOG_DATA) private data,
    private router: Router) {
    this.powerSupplyName = this.data.powerSupplyName;
    this.nodeId = this.data.nodeId;
    this.nonComcast = this.data.nonComcast;
  }

  ngOnInit() {
  }

  onclickOK() {
    this.dialogRef.close();
    this.router.navigate(['/list'], { queryParams: { nodeId: this.nodeId }});
  }
}
